import React from 'react'
import { FaRegHeart } from "react-icons/fa";
import { FaHeart } from "react-icons/fa";
import { FaHandHolding } from "react-icons/fa";

const SupportIcon = ({ glow }) => {
	return (
		<span className="supportIcon">
			{glow ?
				<FaHeart className='text-lg mb-[-10px] fill-[#00fffc] drop-shadow-[0_0_4px_#00fffc]' />
				:
				<FaRegHeart className='text-lg heartFlicker mb-[-10px] fill-[#00fffc]' />
			}
			<FaHandHolding className='text-2xl fill-[#ffc573]' />
		</span>
	)
}

export default SupportIcon